import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import Classes, { ACHFromAccount, Account, CompanyAccount } from "model";
import { useEffect } from "react";
export default function CaptureTemplateDetailsACHParticipantsGroupNameEntered(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const { branding } = context.state;
 let hasLOC = context.state.branding.options.loc_primary_abi22 == "true"; 
  BCMSRecord.globalControllerFor(Classes, context);
  let selectedAccount = hasLOC ? Account.initByID(10) :Account.initByID(5);
  const achFromAccount = ACHFromAccount.init({ account: selectedAccount.id, id: ACHFromAccount.nextID() });

  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["template", "transactionType"], "payment")
    .update(["template", "secCode"], "PPD Credit - Consumer Credit")
    .update(["template", "name"], "New Payroll")
    .update(["template", "companyDiscretionaryData"], "Bi-Weekly")
    .update(["template", "companyEntryDescription"], "Payroll")
    .update(["template", "companyAccount"], CompanyAccount.initByID(0))
    .update([ "selectedOffsetAccount", "account" ], selectedAccount)
    .update(["achFromAccounts", "accounts"], [achFromAccount])
    .update(["groupSearchValue"], "Employee")
    .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
    .update(["showSecCode", "isActive"], true)
    .update(["showOneTimeACHModal", "isActive"], false)
    .update(["achParticipantsModalIsOpen", "isActive"], true)
    .submit();
 useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

  return (
    <TemplateDetailsPage ui={ui} data={data} />
  )
}
